import React, {FC} from "react";
import {Tag, Tooltip} from "antd";
import moment from "moment";
import i18n from "../../../services/i18n";
import {InvoiceSentStatus, InvoiceSentStatusResult} from "./getInvoiceSentStatus";

type Props = {
    statusResult: InvoiceSentStatusResult;
};

const formatDate = (date: Date | null): string => (date ? moment(date).format("L") : "—");

const InvoiceSentStatusTag: FC<Props> = ({statusResult}) => {
    const tr = i18n.containers.invoice.SettlementDetails.invoiceSentStatus;

    let color: string;
    let label: string;
    let tooltip: string;

    switch (statusResult.status) {
        case InvoiceSentStatus.NotSent:
            color = "red";
            label = tr.notSent.label();
            tooltip = tr.notSent.tooltip();
            break;
        case InvoiceSentStatus.OutdatedVersionSent:
            color = "orange";
            label = tr.outdatedVersionSent.label();
            tooltip = tr.outdatedVersionSent.tooltip({
                sentDate: formatDate(statusResult.lastSendDate),
                correctionDate: formatDate(statusResult.outdatedSinceDate),
            });
            break;
        case InvoiceSentStatus.CurrentVersionSent:
            color = "blue";
            label = tr.currentVersionSent.label();
            tooltip = tr.currentVersionSent.tooltip({
                sentDate: formatDate(statusResult.lastSendDate),
            });
            break;
        case InvoiceSentStatus.CurrentVersionOpened:
            color = "green";
            label = tr.currentVersionOpened.label();
            tooltip = tr.currentVersionOpened.tooltip({
                sentDate: formatDate(statusResult.lastSendDate),
                openedDate: formatDate(statusResult.openedDate),
            });
            break;
        default:
            return null;
    }

    return (
        <Tooltip title={tooltip}>
            <Tag color={color} style={{cursor: "help"}}>
                {label}
            </Tag>
        </Tooltip>
    );
};

export default InvoiceSentStatusTag;
